import type { AppBuild } from '@khaddi/ui';

export const APP_BUILD: AppBuild = { version: __APP_VERSION__, build: __APP_BUILD__ };
